import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'query-string';

import Page from '../../components/global/Page';
import InternalHeader from '../../components/global/InternalHeader';
import {
  setUser,
  setCredentials,
  useAuthState,
  useAuthDispatch,
} from '../../context';
import { login, getProfile } from '../../libs/apis';

function LoginPage() {
  const { t } = useTranslation();
  const dispatch = useAuthDispatch();
  const { user } = useAuthState();
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search);
  const u = search.u || null;

  const initialState = {
    username: '',
    password: '',
    error: false,
    message: '',
    loading: false,
  };

  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };

  const { username, password, error, message, loading } = state;

  if (user) {
    history.push('/');
  }

  const handleProfile = async token => {
    setState({ loading: true, error: false, message: '' });
    await getProfile(token)
      .then(resp => {
        if (resp.status === 200) {
          if (resp.data.response) {
            setUser(dispatch, resp.data.response);
          }
        } else {
          setState({ error: true, message: resp.data.error.message });
        }
        if (search.redirect) {
          //history.push(search.redirect)
        } else {
          //history.push('/profile');
        }
      })
      .catch(err => {
        console.log('err', err);
        setState({ error: true, message: 'Error' });
      })
      .finally(() => {
        setState({ loading: false });
      });
  };

  const handleLogin = async e => {
    e.preventDefault();
    setState({ loading: true, error: false, message: '' });
    const payload = {
      username,
      password,
    };
    await login(payload)
      .then(resp => {
        if (resp.status === 200) {
          if (resp.data.response.token) {
            setCredentials(resp.data.response);
            handleProfile(resp.data.response.token);
          }
        } else {
          setState({
            error: true,
            message: resp.data.error.message,
            loading: false,
          });
        }
      })
      .catch(err => {
        console.log('err', err);
        setState({ error: true, message: 'Error' });
      })
      .finally(() => {
        console.log('finish login');
      });
  };
  useEffect(() => {
    setState({ error: false, loading: false, message: '' });
  }, [history]);

  return (
    <div className="app-container">
      <InternalHeader go="/" title={t('login_page')} />
      <div className="main-content py-3">
        <Page>
          {/* <h1 className="mb-3 text-center">Login</h1> */}
          {error ? (
            <div className="alert alert-danger fade show" role="alert">
              {message}
            </div>
          ) : null}
          <form onSubmit={handleLogin}>
            <div className="p-3">
              {u === 'seller' && (
                <h5 className=" mb-3 text-center">
                  {t('login_page_seller_heading')}
                </h5>
              )}
              {!u && (
                <h5 className=" mb-3 text-center">{t('login_page_heading')}</h5>
              )}

              <div className="form-floating mb-3">
                <input
                  className="form-control"
                  type="text"
                  id="email"
                  required
                  value={username}
                  onChange={e => setState({ username: e.target.value })}
                  disabled={loading}
                  placeholder={t('username_label')}
                />
                <label htmlFor="email">{t('username_label')}</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  className="form-control"
                  type="password"
                  id="password"
                  required
                  minLength="8"
                  value={password}
                  onChange={e => setState({ password: e.target.value })}
                  disabled={loading}
                  placeholder={t('password_label')}
                />
                <label htmlFor="password">{t('password_label')}</label>
              </div>

              <button
                className="btn mt-1 bg-gradient btn-lg btn-primary shadow w-100"
                type="submit"
                disabled={loading}
              >
                {t('login_button')}
              </button>
            </div>
          </form>

          <div
            className="p-4 py-5 border-top  text-center"
            style={{ margin: '0 -0.75rem' }}
          >
            <h3>{t('or_register_heading')}</h3>
            <div className="row my-3">
              <div className="col col-sm-6">
                <Link
                  to="/register-seller"
                  className="btn btn-lg bg-gradient shadow btn-primary lh-sm w-100"
                >
                  <span className="text">
                    <small>{t('login_button')}</small>
                    <br />
                    <strong>{t('seller')}</strong>
                  </span>
                </Link>
              </div>
              <div className="col col-sm-6">
                <Link
                  to="/register-buyer"
                  className="btn shadow bg-gradient btn-outline-primary btn-lg lh-sm w-100"
                >
                  <span className="text">
                    <small>{t('login_button')}</small>
                    <br />
                    <strong>{t('buyer')}</strong>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </div>
  );
}

export default LoginPage;
